import { factListConfiguration } from '../fact/FactList/configurations/FactList.configuration.js';

import { factConfiguration as factComponentConfiguration } from './Fact/configurations/Fact.configuration.js';
import { summaryBlockConfiguration } from './SummaryBlock/configurations/SummaryBlock.configuration.js';
import { summaryBlocksConfiguration } from './SummaryBlocks/configurations/SummaryBlocks.configuration.js';
import { IFactConfiguration } from './IFactConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const factConfiguration: IFactConfiguration = {
	summaryBlock: summaryBlockConfiguration,
	summaryBlocks: summaryBlocksConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
	fact: factComponentConfiguration,
	factList: factListConfiguration,
};
